import React, {useState} from 'react'
import {Block, Row} from 'jsxstyle'
import {CopilotConversationDto} from '../../../services/CopilotConversation/type'
import {formatDate} from '../../../common/utils/dateUtils'
import {ReactComponent as TrashIcon} from '../../../common/assets/trash-icon.svg'
import QuickConfirmDialog from '../../../components/QuickConfirmDialog'

interface CopilotConversationRowProps {
  conversation: CopilotConversationDto
  onSelect: (conversation: CopilotConversationDto) => void
  onDelete: (conversationId: string) => Promise<void>
}

const CopilotConversationRow: React.FC<CopilotConversationRowProps> = ({conversation, onSelect, onDelete}) => {
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
  const [deleteIsHovered, setDeleteIsHovered] = useState(false)

  return (
    <Row
      padding="12px"
      borderRadius="8px"
      backgroundColor="#f9faff"
      marginBottom="8px"
      cursor="pointer"
      alignItems="center"
      justifyContent="space-between"
      hoverBackgroundColor="#f0f5ff"
    >
      <Block
        flex="1"
        props={{
          onClick: () => onSelect(conversation),
        }}
      >
        <Block fontWeight={500} fontSize="14px" marginBottom="4px">
          {conversation.title || 'Untitled Conversation'}
        </Block>
        <Block fontSize="12px" color="#666">
          {formatDate(conversation.createdAt)}
        </Block>
      </Block>

      <Row
        alignItems="center"
        backgroundColor="transparent"
        borderRadius="4px"
        border="1px solid #F1164A"
        hoverBackgroundColor="#F1164A"
        padding="6px"
        cursor="pointer"
        justifyContent="center"
        props={{
          onClick: (e) => {
            e.stopPropagation()
            setOpenDeleteConfirm(true)
          },
          onMouseEnter: () => setDeleteIsHovered(true),
          onMouseLeave: () => setDeleteIsHovered(false),
        }}
      >
        <TrashIcon height={16} width={16} color={deleteIsHovered ? '#FFFFFF' : '#EF2D2D'} />
      </Row>

      <QuickConfirmDialog
        key={conversation.id}
        open={openDeleteConfirm}
        setOpen={() => setOpenDeleteConfirm(false)}
        title="Confirm Deletion"
        content={'Are you sure you want to delete this conversation?\nThis action cannot be reversed!'}
        buttons={[
          {
            title: 'Delete',
            onClick: () => {
              onDelete(conversation.id)
            },
            closeOnClick: true,
            customButtonProps: {
              backgroundColor: '#F1164A',
              hoverBackgroundColor: '#C41E2C',
              color: '#FFFFFF',
            },
          },
        ]}
      />
    </Row>
  )
}

export default CopilotConversationRow
